import React from "react";
import AuthRouter from "../router/AuthRouter";

function AuthFlow(props) {
  return <AuthRouter />;
}

export default AuthFlow;
